// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__2-m1s","main":"style_main__23h7H","buttons":"style_buttons__1IbJq","save":"style_save__BIeSW"};